import FooterCompact from './FooterCompact'
export type * from './types'
export default FooterCompact
